import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private jsonUrl = 'assets/data/notifications.json'; // Path to JSON file

  constructor(private http: HttpClient) {}

  getNotifications(): Observable<any> {
    return this.http.get<any[]>(this.jsonUrl).pipe(
      map(notifications => ({
        data: notifications
      }))
    );
  }

  deleteNotification(id: number): Observable<any> {
    // Since we're using JSON file, this will just return success
    // In real app, this would call backend API
    return new Observable(observer => {
      console.log('Delete notification:', id);
      observer.next({ success: true });
      observer.complete();
    });
  }

  markAsRead(id: number): Observable<any> {
    // Since we're using JSON file, this will just return success
    // In real app, this would call backend API
    return new Observable(observer => {
      console.log('Mark as read:', id);
      observer.next({ success: true });
      observer.complete();
    });
  }
}

// import { Injectable } from '@angular/core';
// import { HttpClient } from '@angular/common/http';
// import { Observable } from 'rxjs';

// @Injectable({
//   providedIn: 'root'
// })
// export class NotificationService {

//   private baseUrl = '${environment.apiUrl}/admin'; // ⬅ Replace only this

//   constructor(private http: HttpClient) {}

//   /** GET ALL NOTIFICATIONS */
//   getNotifications(): Observable<any> {
//     return this.http.get(`${this.baseUrl}`);
//   }

//   /** MARK READ */
//   markAsRead(id: number): Observable<any> {
//     return this.http.patch(`${this.baseUrl}/${id}/read`, {});
//   }

//   /** DELETE */
//   deleteNotification(id: number): Observable<any> {
//     return this.http.delete(`${this.baseUrl}/${id}`);
//   }
// }
